var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1732608984682,
    className: "icon",
    viewBox: "0 0 1188 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 7539,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 580.078125,
    height: 500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1038.938992 820.286472h-264.827586c0 74.69496 61.114058 135.809019 135.809018 135.809019 19.013263-0.679045 34.6313 14.259947 35.310345 32.594164 0.679045 19.013263-14.259947 34.6313-32.594164 35.310345H295.384615c-31.236074-31.236074-11.543767-67.904509 17.655173-67.904509 74.69496 0 135.809019-61.114058 135.809018-135.809019H149.38992c-74.69496 0-135.809019-60.435013-135.809018-149.38992V122.228117C13.580902 60.435013 74.015915 0 149.38992 0h889.549072c74.69496 0 135.809019 60.435013 135.809019 122.228117v548.668435c0 88.275862-60.435013 149.38992-135.809019 149.38992z m67.904509-218.65252V134.450928c0-28.519894-23.087533-51.607427-51.607427-51.607427H133.092838c-28.519894 0-51.607427 23.087533-51.607427 51.607427v467.183024c0 28.519894 23.087533 51.607427 51.607427 51.607427h922.143236c28.519894 0 51.607427-23.087533 51.607427-51.607427z",
    fill: "#0052a6",
    "p-id": 7540
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/online.8934ada6560c41622303cd681e1d71e8.svg";
export { ForwardRef as ReactComponent };